import { DIGITAL_TRAP_TAB_LOADING } from '../../domain/tests-id.constants';
import { Container, LoadingText, StyledLoadingIcon } from './tab-loading.styles';

interface TabLoadingProps {
  text: string;
}

export const TabLoading = ({ text }: TabLoadingProps) => {
  return (
    <Container data-testid={DIGITAL_TRAP_TAB_LOADING}>
      <StyledLoadingIcon />
      <LoadingText>{text}</LoadingText>
    </Container>
  );
};
